var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSpinner)?_c('div',{staticClass:"spinner-container"},[_c('sIcon',{staticClass:"my-auto mx-auto",attrs:{"color":"var(--secondary__green_not_active)","size":"58","spin":"","type":"loading"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }